export default __webpack_public_path__ + "static/media/analytics-marketing-team-2.da250e5d.svg";